import classNames from 'classnames';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { H4 } from 'UIComponents/elements/headings';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ACForbiddenError = ({
  className,
  href,
  to = '/',
  'data-test-id': dataTestId = 'forbidden-error'
}) => /*#__PURE__*/_jsxs(UIErrorMessage, {
  className: classNames('missing-content-error', className),
  "data-test-id": dataTestId,
  illustration: "lock",
  title: /*#__PURE__*/_jsx(H4, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.forbidden.heading"
    })
  }),
  type: "403",
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.forbidden.subheading"
    })
  }), href ? /*#__PURE__*/_jsx(UIButton, {
    href: href,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.missingContent.button"
    })
  }) : /*#__PURE__*/_jsx(UIRouterButton, {
    to: to,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.missingContent.button"
    })
  })]
});
export default ACForbiddenError;